<template>
  <router-view />
</template>

<script>
import { unRegisterMixin } from '@/mixin/storeGenerator';

export default {
  name: 'WrapperMaterialsEquipmentRequest',
  mixins: [unRegisterMixin],
  data() {
    return {
      moduleName: 'MaterialsEquipmentRequestModule',
    };
  },
};
</script>
